'use es6';

import PropTypes from 'prop-types';
import PromptablePropInterface from 'UIComponents/decorators/PromptablePropInterface';
import OptInFlowContainerModal from './OptInFlowContainerModal';
import { jsx as _jsx } from "react/jsx-runtime";
const GmailInboxConnectOptInFlowContainerModal = props => /*#__PURE__*/_jsx(OptInFlowContainerModal, Object.assign({}, props, {
  langKey: "gmail"
}));
GmailInboxConnectOptInFlowContainerModal.propTypes = Object.assign({}, PromptablePropInterface, {
  allowRequestGroup: PropTypes.string.isRequired
});
export default GmailInboxConnectOptInFlowContainerModal;